import { Component } from '@angular/core'

@Component({
  selector: 'se-po-add-guardian-docs',
  templateUrl: './add-guardian-docs.component.html',
  styleUrls: ['./add-guardian-docs.component.scss'],
  standalone: false,
})
export class AddGuardianDocsComponent {
}
